import { useCallback } from "react"
import { useNavigate, NavigateOptions, To } from "react-router-dom"

export default function useTypedNavigate (): (route: PageNames | To, options?: NavigateOptions) => void {
  const navigate = useNavigate()

  // `options` is forwarded so callers can pass `{replace: true}` — the auth
  // forms need it, otherwise Back from the post-login page lands on the login
  // form again (which immediately re-redirects, trapping the visitor).
  return useCallback((route: PageNames | To, options?: NavigateOptions): void => {
    navigate(route, options)
  }, [navigate])
}
